import { call, put, takeLatest } from 'redux-saga/effects';
import apiCall from '../helpers/ApiCall';
import apiRoot from '../consts/apiRoot';
import { SET_LOADER } from '../redux/Loader';
import { FETCH_INITIAL_FORM_DETAILS, FETCH_INITIAL_FORM_DETAILS_FAIL,
         FETCH_INITIAL_FORM_DETAILS_SUCCESS } from '../redux/Ads';
import { GET } from '../consts/Methods';

function* FetchAdFormInitialDetailsFlow({ payload, }) {
  try {
    yield put(SET_LOADER({ value: true, }));
    const endpoint = `${apiRoot}/ads/initial_form_details`;
    const params = { offer_id: payload, };
    const data = yield call(apiCall, { method: GET, endpoint, params, });
    yield put(FETCH_INITIAL_FORM_DETAILS_SUCCESS(data));
  } catch (error) {
    yield put(FETCH_INITIAL_FORM_DETAILS_FAIL(error));
  } finally {
    yield put(SET_LOADER({ value: false, }));
  }
}

export default function* FetchAdFormInitialDetails() {
  yield takeLatest(FETCH_INITIAL_FORM_DETAILS, FetchAdFormInitialDetailsFlow);
}
